const qimaKeys = {
  // PCT_Kilos: "Kilos",
  // PCT_Grower: "Productor",
  // PCT_10Pieces_Weight: "Peso 10 frutos",
  // _L_CasesQTY: "Cajas muestra",
  // _L_Customer_Reference_Code: "Guia",
  // _L_Lot_Number: "Lote",
  // _P_Pallet_Number: "Numero de pallet",
  // _L_Organic_Display: "Tipo de Producto",
  // PCT_Cases_Sample: "Cajas muestra",
  // PCT_Sample_Weight: "Tamano muestra",
  SYS_FinalScore_Name: "QC",
  PCT_Sum_of_Quality_Defects: "Suma defectos calidad",
  PCT_Sum_of_Condition_Defects: "Suma defectos condicion",
  PCT_Sum_of_Total_Defects: "Suma defectos totales",
  _L_Date_Inspection: "Fecha inspeccion",
  PCT_Main_Defects: "Defecto principal",
  PCT_Brix: "Brix",
  PCT_Baxlo: "Baxlo",
  PCT_Dirt: "Tierra",
  PCT_Dust: "Polvo", //no estaba en excell/
  PCT_Mold: "Micelio",
  PCT_Soft: "Blando",
  PCT_Block: "Jugo", //no estaba en excell/
  PCT_Decay: "Pudricion", //no estaba en excell/
  PCT_Splits: "Partiduras",
  PCT_Bruises: "Machucon",
  PCT_Crushed: "Reventado",
  PCT_No_Bloom: "Sin Bloom",
  PCT_Overripe: "Sobremaduro",
  PCT_Undersize: "Bajo calibre",
  PCT_Shriveling: "Deshidratado",
  PCT_Broken_Skin: "Desgarro peduncular",
  PCT_Open_Wounds: "Heridas Abiertas",
  PCT_Sample_Size: "Peso muestra",
  PCT_Temperature: "Temperatura",
  PCT_Wet_Berries: "Exudacion jugo",
  PCT_Frost_Damage: "Heladas", //no estaba en excel//
  PCT_Underweight: "Bajo peso",
  PCT_Russet_Scars: "Russet/Cicatrices",
  PCT_Size_More_16mm: "Calibre >16mmm",
  PCT_Size_14_15_9: "Calibre 14-15.9 mm",
  PCT_Size_12_13_9: "Calibre 12-13.9 mm",
  PCT_Size_Distribution_Less12mm: "Calibre < 12mm",
  PCT_Lack_of_Color: "Falta color", //no estaba en excel//
  PCT_Attached_Stems: "Pedunculo",
  PCT_Flower_Remains: "Restos florales",
  PCT_Immature_Green: "Inmadura verde",
  PCT_Shrivel_Severe: "Deshidratacion",
  PCT_Insect_Presence: "Presencia de insecto"
  // PCT_Baxlo_Distribution_GreaterEqual70: "Dist. Baxlo mayor 75",
  // PCT_Baxlo_Distribution_Between65_and69: "Dist. baxlo entre 65 y 69",
  // PCT_Baxlo_Distribution_Between60_and64: "Dist. Baxlo entre 60 y 64",
  // PCT_Baxlo_Distribution_Less60: "Dist. Baxlo menor 60"
  // PCT_Label: "Etiqueta",
  // _L_Name_Product: "Producto",
  // _L_Name_Company: "Exportadora",
  // _L_Warehouse: "Cuartel", //duda//
  // PCT_Hail: "", //no estaba en excell/
  // PCT_Package: "Embalaje",
  // PCT_Variety: "Variedad",
  // ___KP_ID: "2211220787630541903",
  // _L_Vessel: "", //no estaba en excell/
  // _L_Link_Web: "http://tinyurl.com/2mr9wmrr",
  // __KF_LOTS_ID: "2211220748301861717",
  // PCT_Sensitive: "", //no estaba en excell/
  // PCT_Net_Weight: "Peso neto",
  // PCT_Destination: "Destino",
  // PCT_Score_Final: "Sample score",
  // _L_Carrier_Type: "", //no estaba en excel//
  // _L_Date_Arrival: "", //no estaba en excel//
  // _L_Name_Shipper: "Productor",
  // __KF_PALLETS_ID: "2211220787634022980",
  // PCT_Packing_Date: "Fecha embalaje",
  // _L_Name_Location: "Chile, Chillan",
  // _L_Date_Warehouse: "", //no estaba en excel//
  // PCT_Shrivel_Moderate: "", //no estaba en excel//
  // PCT_Sample_Additional: "Sobre muestra",
  // PCT_Wounds_Not_Healed: "", //no estaba en excel//
  // PCT_Sum_of_Major_Defects: "", //no estaba en excel//
  // PCT_Sum_of_Minor_Defects: "", //no estaba en excel//
  // SYS_FinalScore_Color_Hex: "Color score final",
  // _L_Name_Product_Services: "Rejillas",
  //no encontrados :   pallet score, Baxlo promedio, Brix promedio, Inmadura roja, Contaminacióm//
};

export default qimaKeys;
